import assignOffsetPagination from "@/schemas/assignOffsetPagination";

import TikTokPostSchema from "./TikTokPostSchema";

const TikTokPostsResponseSchema = assignOffsetPagination(TikTokPostSchema);

export default TikTokPostsResponseSchema;
